(() => {
  'use strict';
  document.querySelectorAll('[data-buce-progressive-catalog]').forEach(root => {
    const form = root.querySelector('form');
    const details = root.querySelector('details');
    const status = root.querySelector('[data-buce-filter-status]');
    const copy = JSON.parse(root.querySelector('[data-buce-catalog-copy]').textContent);
    let request = null, revision = 0;
    let brandChosen = !!form.querySelector('[data-shoe-step="marca"]')?.value;
    const fields = () => [...form.querySelectorAll('select[data-shoe-step]')];
    const enableSteps = () => {
      const size = form.querySelector('[data-shoe-step="talla"]');
      const brand = form.querySelector('[data-shoe-step="marca"]');
      const color = form.querySelector('[data-shoe-step="categoria"]');
      if (brand) brand.disabled = !size?.value;
      if (color) color.disabled = !size?.value || !brandChosen;
    };
    if (fields().some(el => el.value && el.dataset.shoeStep !== 'categoria')) details.open = true;
    enableSteps();
    const update = async (resetPath = null) => {
      const current = ++revision;
      const selections = fields().filter(el => el.dataset.shoeStep !== 'categoria' && el.value).map(el => ({step:el.dataset.shoeStep,value:el.value,label:el.selectedOptions[0]?.textContent || el.value}));
      request?.abort();
      request = new AbortController();
      const url = new URL(location.href);
      const category = form.querySelector('[data-shoe-step="categoria"]');
      if (resetPath) url.pathname = resetPath;
      else if (category && !category.disabled && category.value) url.pathname = category.value;
      [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key); });
      url.searchParams.set('view', 'zapatillas');
      const sort = form.querySelector('[data-buce-sort]');
      if (sort?.value) url.searchParams.set('sort_by', sort.value);
      fields().forEach(el => { if (el.dataset.shoeStep !== 'categoria' && el.value && !el.disabled) url.searchParams.set(el.name, el.value); });
      url.searchParams.set('filter.v.availability', '1');
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', root.dataset.sectionId);
      root.setAttribute('aria-busy', 'true');
      status.textContent = copy.loading;
      try {
        const response = await fetch(fetchUrl, {signal:request.signal});
        if (!response.ok) throw new Error('catalog response');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-buce-progressive-catalog]');
        if (!incoming) throw new Error('catalog section');
        if (current !== revision) return;
        const focusedStep = document.activeElement?.dataset.shoeStep;
        const focusedSort = document.activeElement?.hasAttribute('data-buce-sort');
        form.querySelector('[data-buce-filter-fields]').replaceChildren(...incoming.querySelector('[data-buce-filter-fields]').childNodes);
        selections.forEach(selection => {
          const select = fields().find(el => el.dataset.shoeStep === selection.step);
          if (!select) return;
          if (![...select.options].some(option => option.value === selection.value)) {
            const option = document.createElement('option');
            option.value = selection.value;
            option.textContent = selection.label;
            select.appendChild(option);
          }
          select.value = selection.value;
        });
        root.querySelector('[data-buce-filter-results]').replaceChildren(...incoming.querySelector('[data-buce-filter-results]').childNodes);
        enableSteps();
        window.history.replaceState(null, '', url);
        status.textContent = copy.ready;
        window.BuceGreenUI?.refresh();
        document.dispatchEvent(new CustomEvent('buce:catalog-result', {detail:{root:root}}));
        document.dispatchEvent(new CustomEvent('shopify:section:load', {detail:{sectionId:root.dataset.sectionId}}));
        if (focusedSort) form.querySelector('[data-buce-sort]')?.focus({preventScroll:true});
        if (focusedStep) form.querySelector('[data-shoe-step="' + focusedStep + '"]')?.focus({preventScroll:true});
      } catch (error) {
        if (error.name !== 'AbortError' && current === revision) location.assign(url);
      } finally {
        if (current === revision) root.removeAttribute('aria-busy');
      }
    };
    form.addEventListener('change', event => {
      if (event.target.hasAttribute('data-buce-sort')) { update(); return; }
      const step = event.target.dataset.shoeStep;
      if (!step) return;
      if (step === 'talla') {
        fields().filter(el => el !== event.target).forEach(el => { el.value = el.dataset.shoeStep === 'categoria' ? '/collections/all' : ''; });
        brandChosen = false;
      } else if (step === 'marca') {
        brandChosen = true;
        const color = form.querySelector('[data-shoe-step="categoria"]');
        if (color) color.value = '/collections/all';
      }
      enableSteps();
      update();
    });
    form.addEventListener('submit', event => { event.preventDefault(); update(); });
    form.querySelector('[data-buce-filter-reset]').addEventListener('click', event => {
      event.preventDefault();
      fields().forEach(el => { el.value = el.dataset.shoeStep === 'categoria' ? '/collections/all' : ''; });
      brandChosen = false;
      enableSteps();
      update('/collections/all');
    });
  });
})();
